import React from 'react';

export default function Card({ children, className = '', hover = false, onClick }) {
  const cls = `mol-card ${hover ? 'mol-card--hover' : ''} ${className}`.trim();
  return (
    <div className={cls} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined}>
      {children}
    </div>
  );
}
